import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import TopExperienceLayer from '../components/top/TopExperienceLayer';
import Footer from '../components/layout/Footer';
import { Play, Mail, ArrowRight } from 'lucide-react';

const PRIMARY   = '#1a5d3a';
const GOLD      = '#f5a623';
const CREAM     = '#f5f0e8';
const SAGE      = '#e8f5e9';
const WHITE     = '#FFFFFF';
const _WARM_CARD = '#fff8e7';

const EPISODES = [
  { ep: 17, title: 'Scholarships That Find You',      guest: 'Jordan Lee',     role: 'Scholarship Coach',   duration: '36 MIN' },
  { ep: 16, title: "Careers in AI: What's Real?",     guest: 'Naysa Patel',    role: 'AI Researcher',       duration: '41 MIN' },
  { ep: 15, title: 'From Setback to Comeback',        guest: 'Marcus Hill',    role: 'Student Athlete',     duration: '31 MIN' },
  { ep: 14, title: 'College Apps Decoded',            guest: 'Priya Sharma',   role: 'College Counselor',   duration: '33 MIN' },
  { ep: 13, title: 'Starting Young & Winning',        guest: 'Ethan Young',    role: 'Teen Entrepreneur',   duration: '34 MIN' },
  { ep: 12, title: 'Financial Lit for Teens',         guest: 'Aaliyah Johnson',role: 'Financial Educator',  duration: '32 MIN' },
];

export default function PodcastPage() {
  const [email, setEmail] = useState('');
  const [signed, setSigned] = useState(false);

  const handleSignUp = (e) => {
    e.preventDefault();
    if (email) setSigned(true);
  };

  return (
    <div style={{ background: WHITE, minHeight: '100vh' }}>
      <TopExperienceLayer />

      {/* ── HERO ── */}
      <section style={{ background: PRIMARY, padding: '64px 0 72px', position: 'relative', overflow: 'hidden' }}>
        {/* Ambient text */}
        <div className="absolute inset-0 flex flex-col justify-between py-8 px-8 pointer-events-none select-none overflow-hidden" aria-hidden>
          {['DREAM BIG', 'YOUR FUTURE', 'YOUR DREAM'].map((t, i) => (
            <div key={t} className="font-black tracking-widest"
              style={{
                color: 'rgba(255,255,255,0.05)',
                fontSize: '4rem',
                transform: i % 2 === 0 ? 'rotate(-15deg) translateX(-5%)' : 'rotate(15deg) translateX(60%)',
                whiteSpace: 'nowrap',
              }}
            >{t}</div>
          ))}
        </div>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          {/* Branding */}
          <div className="flex items-center gap-2 mb-8">
            <div className="w-10 h-10 flex items-center justify-center"
              style={{ border: '2px solid rgba(255,255,255,0.4)', borderRadius: '6px', background: 'rgba(255,255,255,0.1)' }}>
              <svg viewBox="0 0 20 24" fill="none" style={{ width: 20, height: 24 }}>
                <rect x="1" y="1" width="18" height="22" rx="2" stroke={GOLD} strokeWidth="1.5" fill="none" />
                <rect x="4" y="4" width="12" height="16" rx="1" fill="rgba(255,255,255,0.15)" />
                <circle cx="14" cy="12" r="1.2" fill={GOLD} />
              </svg>
            </div>
            <div>
              <div className="text-xs font-black tracking-widest text-white">STUDENT DOOR</div>
              <div className="text-xs tracking-widest text-white/50">— PODCAST —</div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div>
              <h1 className="font-black leading-none mb-0 text-white"
                style={{ fontSize: 'clamp(4rem, 10vw, 7rem)', letterSpacing: '-0.03em', lineHeight: 0.88 }}>
                STUDENT
              </h1>
              <h1 className="font-black leading-none mb-6"
                style={{ color: GOLD, fontSize: 'clamp(4rem, 10vw, 7rem)', letterSpacing: '-0.03em', lineHeight: 0.88 }}>
                DOOR
              </h1>
              <p className="mb-8 text-white/80" style={{ fontSize: '1.2rem', lineHeight: 1.5 }}>
                the twice-monthly podcast that gives you{' '}
                <span className="font-black" style={{ color: GOLD, borderBottom: `3px solid ${GOLD}` }}>more.</span>
              </p>
              <div className="flex flex-wrap gap-3">
                <button
                  className="flex items-center gap-3 px-6 py-3 font-black text-sm transition-all hover:opacity-90"
                  style={{ background: GOLD, color: '#0a0a0a', borderRadius: '8px', letterSpacing: '0.04em' }}
                >
                  <Play size={18} fill="#0a0a0a" />
                  LISTEN NOW
                </button>
                <button
                  className="flex items-center gap-3 px-6 py-3 font-black text-sm transition-all"
                  style={{ border: '2px solid rgba(255,255,255,0.4)', color: WHITE, borderRadius: '8px', letterSpacing: '0.04em' }}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
                    <path d="M23.5 6.2c-.3-1-1-1.8-2-2.1C19.7 3.6 12 3.6 12 3.6s-7.7 0-9.5.5c-1 .3-1.7 1.1-2 2.1C0 8 0 12 0 12s0 4 .5 5.8c.3 1 1 1.8 2 2.1C4.3 20.4 12 20.4 12 20.4s7.7 0 9.5-.5c1-.3 1.7-1.1 2-2.1.5-1.8.5-5.8.5-5.8s0-4-.5-5.8zM9.8 15.4V8.6l6.4 3.4-6.4 3.4z" />
                  </svg>
                  WATCH ON YOUTUBE
                </button>
              </div>
            </div>

            {/* Right — door graphic */}
            <div className="hidden lg:flex items-center justify-center">
              <div className="relative" style={{ width: 280, height: 340 }}>
                <div className="absolute inset-0 rounded-t-full"
                  style={{ background: 'rgba(255,255,255,0.08)', border: '2px solid rgba(255,255,255,0.2)', borderRadius: '140px 140px 8px 8px' }} />
                <div className="absolute"
                  style={{
                    inset: '15px',
                    background: `radial-gradient(ellipse at center top, rgba(245,166,35,0.5) 0%, rgba(245,166,35,0.1) 40%, transparent 70%)`,
                    borderRadius: '120px 120px 4px 4px', filter: 'blur(8px)',
                  }} />
                <div className="absolute flex flex-col items-center justify-center"
                  style={{ inset: '20px', borderRadius: '120px 120px 4px 4px', border: '1px solid rgba(245,166,35,0.3)' }}>
                  <div className="text-center px-4 mt-10">
                    {['OPPORTUNITY', 'INSIGHT', 'INSPIRATION', 'FOR YOU.'].map((word, i) => (
                      <div key={word} className="font-black"
                        style={{
                          color: i === 3 ? GOLD : 'rgba(255,255,255,0.85)',
                          fontSize: i === 3 ? '0.9rem' : '0.75rem',
                          letterSpacing: '0.08em', lineHeight: 1.6,
                        }}>{word}</div>
                    ))}
                  </div>
                </div>
                <div className="absolute" style={{ width: 12, height: 12, borderRadius: '50%', background: GOLD, right: 38, top: '50%', boxShadow: `0 0 12px ${GOLD}` }} />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── LATEST EPISODE ── */}
      <section className="py-12" style={{ background: CREAM }}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs font-black tracking-widest uppercase mb-6" style={{ color: PRIMARY }}>
            LATEST EPISODE
          </div>
          <div className="rounded-2xl overflow-hidden" style={{ background: WHITE, border: '1px solid #e0e0e0', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
            <div className="grid grid-cols-1 md:grid-cols-2">
              {/* Placeholder thumbnail */}
              <div className="relative overflow-hidden" style={{ minHeight: 260 }}>
                <div className="bg-gray-200 rounded-lg w-full h-full min-h-48" />
              </div>
              {/* Info */}
              <div className="p-8 flex flex-col justify-center">
                <span className="inline-block px-3 py-1 text-xs font-black rounded mb-4"
                  style={{ background: PRIMARY, color: WHITE }}>
                  EPISODE 18
                </span>
                <h2 className="font-black text-2xl leading-tight mb-2" style={{ color: '#111' }}>
                  Beyond the Ivy: Building Your Own Path
                </h2>
                <div className="font-semibold mb-1" style={{ color: PRIMARY }}>with Isabel Okoro</div>
                <div className="text-sm mb-5" style={{ color: '#888' }}>Founder, YouthBuild Initiative</div>

                <div className="flex items-center gap-4 mb-6">
                  <span className="flex items-center gap-1.5 text-xs font-bold" style={{ color: '#555' }}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: 14, height: 14 }}>
                      <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
                    </svg>
                    42 MINUTES
                  </span>
                  <span className="text-xs" style={{ color: '#ccc' }}>·</span>
                  <span className="text-xs font-bold" style={{ color: '#555' }}>MAY 2025</span>
                </div>

                <div className="flex items-center gap-4 mb-6">
                  <button
                    className="w-14 h-14 rounded-full flex items-center justify-center transition-all hover:opacity-90 flex-shrink-0"
                    style={{ background: GOLD }}
                  >
                    <Play size={22} fill="#0a0a0a" />
                  </button>
                  {/* Waveform */}
                  <div className="flex-1 flex items-center gap-0.5 h-8">
                    {[...Array(40)].map((_, i) => (
                      <div key={i} className="flex-1 rounded-full"
                        style={{
                          height: `${20 + Math.sin(i * 0.8) * 14 + (i * 7 % 9)}%`,
                          background: i < 15 ? GOLD : '#e0e0e0', minWidth: 2,
                        }} />
                    ))}
                  </div>
                </div>

                {/* Platform icons */}
                <div>
                  <div className="text-xs font-bold mb-3" style={{ color: '#999' }}>LISTEN ON</div>
                  <div className="flex gap-3">
                    <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ background: '#1DB954' }}>
                      <svg viewBox="0 0 24 24" fill="white" style={{ width: 18, height: 18 }}>
                        <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" />
                      </svg>
                    </div>
                    <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ background: '#B150E2' }}>
                      <svg viewBox="0 0 24 24" fill="white" style={{ width: 18, height: 18 }}>
                        <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 4.5c2.071 0 3.75 1.679 3.75 3.75S14.071 12 12 12s-3.75-1.679-3.75-3.75S9.929 4.5 12 4.5zm0 15.75c-2.625 0-4.95-1.35-6.3-3.375.825-.6 2.7-1.125 6.3-1.125 3.6 0 5.475.525 6.3 1.125C17.25 18.9 14.925 20.25 12 20.25z" />
                      </svg>
                    </div>
                    <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ background: '#FF0000' }}>
                      <svg viewBox="0 0 24 24" fill="white" style={{ width: 18, height: 18 }}>
                        <path d="M23.5 6.2c-.3-1-1-1.8-2-2.1C19.7 3.6 12 3.6 12 3.6s-7.7 0-9.5.5c-1 .3-1.7 1.1-2 2.1C0 8 0 12 0 12s0 4 .5 5.8c.3 1 1 1.8 2 2.1C4.3 20.4 12 20.4 12 20.4s7.7 0 9.5-.5c1-.3 1.7-1.1 2-2.1.5-1.8.5-5.8.5-5.8s0-4-.5-5.8zM9.8 15.4V8.6l6.4 3.4-6.4 3.4z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── RECENT EPISODES ── */}
      <section className="py-12" style={{ background: WHITE }}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-end justify-between mb-8">
            <div className="text-lg font-black tracking-wide" style={{ color: '#111' }}>RECENT EPISODES</div>
            <button className="flex items-center gap-1 text-xs font-bold uppercase tracking-wide" style={{ color: PRIMARY }}>
              VIEW ALL EPISODES <ArrowRight size={12} />
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {EPISODES.map((ep) => (
              <div key={`${ep.ep}-${ep.title}`}
                className="rounded-xl overflow-hidden transition-all hover:shadow-md"
                style={{ background: SAGE, border: '1px solid #c8e6c9' }}>
                {/* Placeholder guest photo */}
                <div className="relative h-36 overflow-hidden">
                  <div className="bg-gray-200 rounded-lg w-full h-full min-h-48" />
                  <span
                    className="absolute top-3 left-3 px-2 py-1 text-[10px] font-black text-white rounded z-10"
                    style={{ background: PRIMARY }}>
                    EP. {ep.ep}
                  </span>
                </div>
                {/* Info */}
                <div className="p-4">
                  <h3 className="font-black text-sm leading-tight mb-1" style={{ color: '#111' }}>{ep.title}</h3>
                  <div className="text-xs mb-0.5" style={{ color: PRIMARY }}>w/ {ep.guest}</div>
                  <div className="text-xs mb-4" style={{ color: '#888' }}>{ep.role}</div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-1 text-xs" style={{ color: '#666' }}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: 12, height: 12 }}>
                        <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
                      </svg>
                      {ep.duration}
                    </div>
                    <button className="w-8 h-8 rounded-full flex items-center justify-center transition-all hover:opacity-90"
                      style={{ background: GOLD }}>
                      <Play size={12} fill="white" className="text-white" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── EMAIL CAPTURE STRIP ── */}
      <section style={{ background: CREAM, borderTop: '1px solid #e0d8c8', borderBottom: '1px solid #e0d8c8' }}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-8">
            <div>
              <h2 className="font-black leading-tight" style={{ color: '#111', fontSize: 'clamp(1.8rem, 4vw, 2.5rem)', letterSpacing: '-0.02em' }}>
                NEVER MISS <span style={{ color: PRIMARY }}>AN EPISODE.</span>
              </h2>
            </div>
            <div>
              <div className="flex items-center gap-2 mb-3">
                <Mail size={16} style={{ color: PRIMARY }} />
                <span className="text-xs" style={{ color: '#555' }}>
                  Get new episodes, behind-the-scenes content & more — straight to your inbox.
                </span>
              </div>
              {signed ? (
                <div className="py-3 px-4 rounded-lg font-bold text-white text-sm" style={{ background: PRIMARY }}>
                  You&apos;re on the list!
                </div>
              ) : (
                <form onSubmit={handleSignUp} className="flex gap-2">
                  <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    className="flex-1 px-4 py-3 text-sm rounded-lg outline-none bg-white"
                    style={{ border: '1px solid #ddd', color: '#111' }}
                  />
                  <button type="submit"
                    className="px-5 py-3 font-black text-sm whitespace-nowrap transition-all hover:opacity-90 rounded-lg"
                    style={{ background: GOLD, color: WHITE }}>
                    SIGN ME UP
                  </button>
                </form>
              )}
            </div>
            <div className="hidden md:block text-right">
              <div className="font-black italic" style={{ color: '#111', fontSize: '1.5rem', lineHeight: 1.2 }}>
                Your Future<br />is Waiting.<br />
                <span style={{ color: GOLD }}>Press Play.</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── CROSS-LINKS ── */}
      <section className="py-14" style={{ background: PRIMARY }}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-xs font-bold tracking-widest uppercase mb-8 text-white/50">
            MORE FROM STUDENTSIGNAL
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="rounded-xl p-6" style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)' }}>
              <div className="font-black mb-1 text-white text-sm">STUDENT DOOR</div>
              <p className="text-xs mb-4 text-white/60">You&apos;re already here!</p>
              <button className="w-full py-2.5 text-xs font-black rounded text-white" style={{ background: 'rgba(255,255,255,0.15)' }}>
                YOU&apos;RE IN THE RIGHT PLACE
              </button>
            </div>
            <div className="rounded-xl p-6" style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)' }}>
              <div className="font-black mb-1 text-white text-sm">STUDENTSIGNAL MAGAZINE</div>
              <p className="text-xs mb-4 text-white/60">Monthly in-depth guide for students.</p>
              <Link to="/magazine">
                <button className="w-full py-2.5 text-xs font-black rounded" style={{ background: GOLD, color: '#0a0a0a' }}>
                  READ THE MAGAZINE
                </button>
              </Link>
            </div>
            <div className="rounded-xl p-6" style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)' }}>
              <div className="flex items-center gap-2 mb-3">
                <div className="w-7 h-7 flex items-center justify-center font-black text-white text-xs"
                  style={{ background: GOLD, borderRadius: '4px' }}>OK</div>
                <span className="font-black text-white text-sm">NEWSLETTER</span>
              </div>
              <p className="text-xs mb-4 text-white/60">Opportunity Knocks weekly.</p>
              <Link to="/newsletter">
                <button className="w-full py-2.5 text-xs font-black rounded" style={{ background: GOLD, color: '#0a0a0a' }}>
                  SUBSCRIBE TO OK
                </button>
              </Link>
            </div>
          </div>
          <div className="mt-10 text-center">
            <span className="font-black tracking-wide text-white">STUDENT<span style={{ color: GOLD }}>SIGNAL</span></span>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
